import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import App from "../App";

import HomeIndex from "../pages/home/HomeIndex";
import ContactUs from "../pages/contact/ContactUs";
import Blog from "../pages/blog/Blog";
import BlogDetails from "../pages/blog/BlogDetails";
import Activities from "../pages/activities/Activities";
import ActivitiesDetails from "../pages/activities/ActivitiesDetails";
import Project from "../pages/project/Project";
import ProjectDetails from "../pages/project/ProjectDetails";
import Programs from "../pages/programs/Programs";
import ProgramDetails from "../pages/programs/ProgramDetails";
import Privacy from "../pages/privacy/Privacy";
import Terms from "../pages/terms/Terms";
import About from "../pages/about/About";
import ReportViolationsForm from "../pages/reportViolationsForm/ReportViolationsForm";
import NotFound from "../pages/notFound/NotFound";

const IndexRouter = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="" element={<App />}>
          <Route path="/" element={<HomeIndex />} />

          <Route path="/news" element={<Blog />} />
          <Route path="/news/details/:id" element={<BlogDetails />} />

          <Route path="/contact" element={<ContactUs />} />

          <Route path="/activities" element={<Activities />} />
          <Route path="/activities/details" element={<ActivitiesDetails />} />

          <Route path="/project" element={<Project />} />
          <Route path="/project/details" element={<ProjectDetails />} />

          <Route path="/programs" element={<Programs />} />
          <Route path="/programs/details" element={<ProgramDetails />} />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          <Route path="/about" element={<About />} />
          <Route path="/report-violations" element={<ReportViolationsForm />} />

          <Route path="*" element={<Navigate to={"/404"} />} />
          <Route path="404" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default IndexRouter;
